export enum EPromotionType {
  PRODUCT = "PRODUCT",
  ORDER_SUMARY = "ORDER_SUMARY",
}

export interface IPromotionModel {
  type: EPromotionType;
  products?: IProductPromotionModel[];
  order_gift_total_price: string;
  sumary: IPromotionSummaryModel;
}

export interface IProductPromotionModel {
  random_code?: string;
  code?: string;
  discount_percent?: string;
  discounted_price?: string;
  sub_total_amount?: string;
  price?: string;
  price_save?: string;
  promotion_product_total_price?: string;
  gift_promotions?: IProductGiftPromotionModel[];
  quantity: number;
  default_prop?: number;
  feature_id: number;
  name: string;
  note: string;
  img?: string;
}

export interface IPromotionSummaryModel {
  quantity: number;
  total_price: string;
  order_total_amount: number;
  order_discount_amount: number;
  original_total_price: string;
  discount_voucher_amount: string;
  discount_voucher_code: string;
  discount_voucher_name: string;
}

export interface IProductGiftPromotionModel extends IProductPromotionModel {
  options: any[];
}
